import React from 'react';
import { Feature } from '@tencent/workbench';
import { FontSizeFeature as ToolbarFontSizeFeature } from '@src/framework/workbench/ui/font-size/font-size-feature';
import { config } from '@src/framework/workbench/ui/font-size/config';
import FontDropdown from '@framework/workbench/drawer/components/dropdown/font-dropdown';
import { FORM_CONFIGS } from '@framework/workbench/drawer/ui/text/font/font-size/config';

@Feature()
export class FontSizeFeature extends ToolbarFontSizeFeature {
    id = config.id;
    config = config;

    public renderFontSize() {
        return <FontDropdown
            text={this.getFontSizeName()}
            dropContent={this.renderSelectList(true)}
            style={{ minWidth: 62, paddingLeft: 6 }}
            tooltip={FORM_CONFIGS[0].tooltip}
        />;
    }
}
